"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuarryClaim = void 0;
const sail_1 = require("@saberhq/sail");
const react_1 = require("react");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const rewarder_1 = require("../rewarder");
const sdk_1 = require("../sdk");
const context_1 = require("./context");
const useQuarryClaim = () => {
    const { sdkMut } = (0, sdk_1.useQuarrySDK)();
    const { handleTX } = (0, sail_1.useSail)();
    const { rewarderKey, rewardToken } = (0, rewarder_1.useRewarder)();
    const { stakedToken } = (0, context_1.useQuarry)();
    return (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        (0, tiny_invariant_1.default)(sdkMut, "sdk not connected");
        (0, tiny_invariant_1.default)(stakedToken, "staked token");
        (0, tiny_invariant_1.default)(rewardToken, "reward token");
        const authority = sdkMut.provider.wallet.publicKey;
        const rewarderW = yield sdkMut.mine.loadRewarderWrapper(rewarderKey);
        const quarryW = yield rewarderW.getQuarry(stakedToken);
        const minerW = yield quarryW.getMinerActions(authority);
        const claimTX = yield minerW.claim();
        return yield handleTX(claimTX, `Claim ${rewardToken.symbol}`);
    }), [handleTX, rewardToken, rewarderKey, sdkMut, stakedToken]);
};
exports.useQuarryClaim = useQuarryClaim;
//# sourceMappingURL=useQuarryClaim.js.map